import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Confirmation dialog for irreversible account deletion.
 * The destructive action is gated behind typing the confirmation word ("DELETE")
 * so it can never be triggered accidentally. Returns `true` via afterClosed()
 * when the user confirms; the caller performs the actual deletion.
 */
@Component({
  selector: 'app-delete-account-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    TranslateModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
  ],
  templateUrl: './delete-account-modal.component.html',
  styleUrls: ['./delete-account-modal.component.scss'],
})
export class DeleteAccountModalComponent {
  private readonly dialogRef = inject<MatDialogRef<DeleteAccountModalComponent>>(MatDialogRef);

  /** Language-independent confirmation word the user must type to enable deletion. */
  readonly confirmationWord = 'DELETE';

  typedConfirmation = '';

  get canDelete(): boolean {
    return this.typedConfirmation.trim().toUpperCase() === this.confirmationWord;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    if (!this.canDelete) {
      return;
    }
    this.dialogRef.close(true);
  }
}
